const initialState = {
    ReleverFrc: [],
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case "RELEVERFRC_GET":
        return {
          ...state,
          ReleverFrc: action.payload,
        };
      default:
        return state;
    }
  }
  